<mat-card>
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.REFRESH_MODAL.HEADER' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    {{ '+INSTALLATIONS.KANBAN_DASHBOARD.REFRESH_MODAL.DESCRIPTION' | translate }}
  </mat-card-content>
  <mat-card-actions class="buttons">
    <button mat-raised-button (click)="refreshData()" color="primary">
      <span class="refresh-label">
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.REFRESH_MODAL.BUTTON' | translate }}
      </span>
    </button>
  </mat-card-actions>
</mat-card>
